
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/terms",
      function () {
        return require("private-next-pages/policies/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/terms"])
      });
    }
  